class PopupDynamic {
    constructor() {
        this.$popupTemplate = this._checkElementExists('#dynamic-popup-template')
        this.$displayContainer = this._checkElementExists('#dynamic-popup-display-container')
        this.popupHTML = this.$popupTemplate.html()
    }

    removePopup() {
        $('#dynamic-popup-display-container .dynamic-popup-carousel').remove()
        this.popupHTML = this._checkElementExists('#dynamic-popup-template').html()
    }

    _checkElementExists(element) {
        const $element = $(element)

        if ($element.length <= 0) {
            console.error(`${element} does not exist`)
            return
        }

        return $element
    }

    setHTML(html) {
        this.removePopup()
        this.popupHTML = this.popupHTML.replace(/{ popup }/g, html)
        return this
    }

    setPosition(position) {
        this.popupHTML = this.popupHTML.replace(/{ position }/g, position)
        return this
    }

    show() {
        this.$displayContainer.append(this.popupHTML)
    }
}

export default PopupDynamic;
